/**
 * 添加自定义字符串属性，目前用的 ga 收集自定义属性，每个字段有 100 的长度限制，当超过100时，拆分为多个字段，最多4个，单个事件自定义参数总数不能超过 25
 * @param {*} params
 * @param {*} key
 * @param {*} value
 */
export function addStringValueToParams(params, key, value) {
    if (value.length <= 100) {
        params[key] = value;
    }
    else {
        const splitLen = Math.min(Math.ceil(value.length / 100), 4);
        for (let i = 0; i < splitLen; i++) {
            params[i ? `${key}_${i - 1}` : key] = value.substring(i * 100, (i + 1) * 100);
        }
    }
}
